import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { EnviarEmailContatoInputDto } from '../domain/DTOs/input/enviar-email-contato.input.dto';
import { EstruturaRetornoOutputDto } from '../domain/DTOs/output/estrutura-retorno.output.dto';

@Injectable()
export class EmailService {

  constructor(private baseService: BaseService) {}

  public enviarEmailContato(
    enviarEmailContatoInputDto: EnviarEmailContatoInputDto
  ): Observable<EstruturaRetornoOutputDto> {
    return this.baseService.post('Email/EnviarEmailContato', enviarEmailContatoInputDto);
  }
}
